/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem, RelatedContentModal, RegionField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedRegionsModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related region"
    subtitle="Find a region related to this article"
    okText="ADD REGION"
    onSubmit={({ region }) => onSubmit(region)}
  >
    <RegionField
      label="Choose a region:"
      name="region"
      extra={null}
      wrapperCol={{ span: 24 }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Region is required' }]}
    />
  </RelatedContentModal>
);

const Item = (region) => <InfoItem>{region.name}</InfoItem>;

RelatedRegionsModal.Item = Item;

export default RelatedRegionsModal;
